import React from 'react'
import styled from 'styled-components'
import { Input } from '@seiue/ui'
import { UploadFile } from 'packages/components/UploadFile'

/**
 * 带图片上传的文本输入
 * @param param - 参数
 * @param param.disabled - 是否允许修改
 * @param param.textAreaMode - 是否允许多行文本
 * @param param.textValue - 文本值
 * @param param.onTextValueChange - 文本变化回调
 * @param param.fileList - 文件列表
 * @param param.onFileListChange - 文件变化回调
 * @param param.onDelete - 删除文件回调
 * @param param.allowUploadImage - 是否允许上传图片
 * @returns React.ReactNode
 */
export const InputWithUpload: React.FC<{
  disabled?: boolean
  textAreaMode?: boolean
  textValue?: string
  onTextValueChange?: (v: string) => void
  fileList?: { url: string; name: string }[]
  onFileListChange?: (filelist: string[]) => void
  onDelete?: (i: number) => void
  allowUploadImage?: boolean
}> = ({
  disabled,
  textAreaMode,
  textValue,
  onTextValueChange,
  fileList,
  onFileListChange,
  allowUploadImage,
}) => {
  return (
    <Wrapper>
      <TextAreaWrapper $allowUploadImage={!!allowUploadImage}>
        {textAreaMode ? (
          <Input.TextArea
            value={textValue}
            placeholder="请输入"
            autoSize={{ minRows: 2 }}
            onChange={(e) =>
              onTextValueChange && onTextValueChange(e.target.value)
            }
            disabled={disabled}
          />
        ) : (
          <Input
            placeholder="请输入"
            value={textValue}
            onChange={(e) =>
              onTextValueChange && onTextValueChange(e.target.value)
            }
            disabled={disabled}
          />
        )}
      </TextAreaWrapper>
      {allowUploadImage ? (
        <FileUploadWrapper>
          <UploadFile
            disabled={disabled}
            fileList={fileList}
            onChange={(filelist) => {
              const finalFileList = filelist.map((f) =>
                JSON.stringify({ url: f.url, name: f.name })
              )
              onFileListChange && onFileListChange(finalFileList)
            }}
            content={
              disabled ? null : <UploadButton>上传图片/附件</UploadButton>
            }
          />
        </FileUploadWrapper>
      ) : null}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 8px 12px;
  border-radius: 8px;
  gap: 8px;
  background-color: ${(props) => props.theme.background._3};

  &&& {
    .ant-input {
      border: none;
      padding: 0 0;
      background-color: ${(props) => props.theme.background._3};
    }
    .ant-input-disabled {
      color: ${(props) => props.theme.text._1};
    }
    .ant-upload-list-picture-card {
      position: relative;
      min-height: 28px;
    }
    .ant-upload-select-picture-card {
      position: absolute;
      right: 0;
      bottom: 0;
      border: none;
      border-radius: 8px;
      background-color: transparent;
      margin: 0 0;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
`

const TextAreaWrapper = styled.div<{
  $allowUploadImage: boolean
}>`
  width: 100%;
  flex-grow: 1;
`

const FileUploadWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

const UploadButton = styled.div`
  width: 94px;
  height: 28px;
  text-align: center;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 12px;
  line-height: 28px;
  color: ${(props) => props.theme.text._3};
  cursor: pointer;
`
